import React from "react";
import { CommandBarButton, IconButton, Stack } from "@fluentui/react";
import DetailsTable from "../../../../Table/DetailsTable";

const LearningObjectiveTable = ({
    learningObjectives,
    setSelectedLearningObjectiveId,
    loading,
    deleteOnClick,
    editOnClick,
    createOnClick,
    createDisabled
}) => {
    const columns = [
        {
            key: "column1",
            name: "ID",
            fieldName: "crsWhatYouLearnID",
            minWidth: 30,
            maxWidth: 30,
            isResizable: true,
        },
        {
            key: "column2",
            name: "Learning Objective",
            fieldName: "learningObjective",
            minWidth: 300,
            maxWidth: 420,
            isResizable: true,
            onRender: (item) => (
                <Stack horizontal horizontalAlign="space-between">
                    <div>{item.learningObjective}</div>
                    <ContextualMenu
                        editOnClick={editOnClick}
                        deleteOnClick={deleteOnClick}
                    />
                </Stack>
            ),
        },
        {
            key: "column3",
            name: "Order Number",
            fieldName: "orderNumber",
            minWidth: 80,
            maxWidth: 80,
            isResizable: true,
        }
    ];

    const items = learningObjectives ?? [];

    const selectionHook = (items) => {
        setSelectedLearningObjectiveId(items && items[0] && items[0].crsWhatYouLearnID);
    };

    return (
        <DetailsTable
            items={items}
            columns={columns}
            selectionHook={selectionHook}
            loading={loading}
            mainColumn={"learningObjective"}
            style={{
                position: "relative",
                height: "80vh",
                width: "80vw",
            }}
            CommandBar={
                <CommandBarButton
                    iconProps={{ iconName: "Add" }}
                    text="Create"
                    onClick={() => createOnClick()}
                    disabled={createDisabled}
                />
            }
        />
    );
};

const moreIcon = { iconName: "More" };

const ContextualMenu = ({
    editOnClick,
    deleteOnClick,
    ...rest
}) => {
    const menuProps = {
        items: [
            {
                key: "print",
                iconProps: { iconName: "Edit" },
                text: "Edit",
                onClick: () => editOnClick(),
            },
            {
                key: "Delete",
                iconProps: { iconName: "Delete" },
                text: "Delete",
                onClick: () => deleteOnClick(),
            }
        ],
    };

    return (
        <IconButton
            iconProps={moreIcon}
            menuProps={menuProps}
            onRenderMenuIcon={() => { }}
            {...rest}
        />
    );
};

export default LearningObjectiveTable;
